// Product tile size chips: keeps the hidden variant id and the visible price in sync with the chosen size.
class STileForm extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-tile-variant')) return;
      this.#select(input);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #select(input) {
    const idInput = this.querySelector('[data-tile-id]');
    if (idInput instanceof HTMLInputElement) idInput.value = input.value;

    const price = this.querySelector('[data-tile-price] bdi');
    if (price) price.textContent = input.dataset.price || '';

    const compare = this.querySelector('[data-tile-compare]');
    if (compare instanceof HTMLElement) {
      const compareText = input.dataset.compare || '';
      const compareBdi = compare.querySelector('bdi');
      if (compareBdi) compareBdi.textContent = compareText;
      compare.hidden = !compareText;
    }
  }
}

if (!customElements.get('s-tile-form')) {
  customElements.define('s-tile-form', STileForm);
}
